/**
 * FAQ accordions (core Details blocks with the r2c-faq__item or
 * r2c-cif-faq__item class).
 *
 * The browser opens and closes a details element in one frame; the
 * accordions these replace slid (jQuery UI's "swing" at 300ms on the Qi
 * accordion, jQuery's slideDown/slideUp at 400ms on Elementor's). This
 * animates the element's height between its closed and open sizes instead,
 * and — because the items share a name, so only one is open at a time —
 * slides the open one shut while the clicked one slides open. Without
 * JavaScript the name attribute keeps them exclusive on its own.
 */
(function () {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function duration(details) {
		if (reduceMotion.matches) {
			return 0;
		}

		return details.classList.contains('r2c-cif-faq__item') ? 400 : 300;
	}

	function summaryOf(details) {
		return details.querySelector(':scope > summary');
	}

	function finish(details, expanded) {
		details.open = expanded;
		details.style.height = '';
		details.style.overflow = '';
		delete details.dataset.r2cAnimating;
	}

	function run(details, from, to, expanded) {
		const running = details.getAnimations();

		running.forEach(function (animation) {
			animation.cancel();
		});

		details.dataset.r2cAnimating = expanded ? 'open' : 'close';
		details.style.overflow = 'hidden';

		const animation = details.animate(
			{ height: [from + 'px', to + 'px'] },
			{ duration: duration(details), easing: 'ease-in-out' }
		);

		animation.onfinish = function () {
			finish(details, expanded);
		};
	}

	function close(details) {
		run(details, details.offsetHeight, summaryOf(details).offsetHeight, false);
	}

	function open(details) {
		const from = details.offsetHeight;
		const summary = summaryOf(details);

		// Held at its closed height while the content is switched on, so the
		// first frame starts where the element is; measured straight away
		// (reading offsetHeight lays it out) rather than on the next frame,
		// which a background tab never paints.
		details.style.height = from + 'px';
		details.style.overflow = 'hidden';
		details.open = true;

		let to = summary.offsetHeight;

		Array.prototype.forEach.call(details.children, function (child) {
			if (child !== summary) {
				to += child.offsetHeight;
			}
		});

		run(details, from, to, true);
	}

	function siblingsOf(details) {
		const group = details.dataset.r2cGroup;

		if (!group) {
			return [];
		}

		return Array.prototype.filter.call(
			document.querySelectorAll('details[data-r2c-group="' + group + '"]'),
			function (other) {
				return other !== details;
			}
		);
	}

	document.querySelectorAll('details.r2c-faq__item, details.r2c-cif-faq__item').forEach(function (details) {
		const summary = summaryOf(details);

		if (!summary) {
			return;
		}

		// The script takes over the exclusivity, so the closing item can
		// slide shut instead of vanishing.
		if (details.hasAttribute('name')) {
			details.dataset.r2cGroup = details.getAttribute('name');
			details.removeAttribute('name');
		}

		summary.addEventListener('click', function (event) {
			event.preventDefault();

			const opening = !details.open || details.dataset.r2cAnimating === 'close';

			if (opening) {
				siblingsOf(details).forEach(function (other) {
					if (other.open && other.dataset.r2cAnimating !== 'close') {
						close(other);
					}
				});
				open(details);
			} else {
				close(details);
			}
		});
	});
})();
